// src/components/landing-page-builder.js

import React from "react"
import LandingPageContentBlock from "../layouts/LandingPageContentBlock"
import ContentBlockWithImage from "../layouts/ContentBlockWithImage"
import LandingPageCountdown from "../layouts/LandingPageCountdown"
import ExpertSection from "../layouts/ExpertSection"
import ServiceCtas from "../layouts/ServiceCtas"
import ServiceList from "../layouts/ServiceList"
import LandingPageLinks from "../layouts/LandingPageLinks"
import CalendlyEmbed from "../layouts/CalendlyEmbed"

const LandingPageBuilder = ({ layoutData }) => {
  const layoutType = layoutData.fieldGroupName

  /**
   * Default component
   */
  const Default = () => (
    <div>
      In AllLayouts the mapping of this component is missing: {layoutType}
    </div>
  )

  /**
   * Mapping the fieldGroupName(s) to our components
   */
  const layouts = {
    CustomPage_Landingpagega4_LandingPageBuilder_LandingPageContentBlock: LandingPageContentBlock,
    CustomPage_Landingpagega4_LandingPageBuilder_ContentBlockWithImage: ContentBlockWithImage,
    CustomPage_Landingpagega4_LandingPageBuilder_CountdownSection: LandingPageCountdown,
    CustomPage_Landingpagega4_LandingPageBuilder_ExpertSection: ExpertSection,
    CustomPage_Landingpagega4_LandingPageBuilder_ServiceCtas: ServiceCtas,
    CustomPage_Landingpagega4_LandingPageBuilder_ServiceList: ServiceList,
    CustomPage_Landingpagega4_LandingPageBuilder_LandingPageLinks: LandingPageLinks,
    CustomPage_Landingpagega4_LandingPageBuilder_CalendlyEmbed: CalendlyEmbed,
    page_default: Default,
  }

  /**
   * If layout type is not existing in our mapping, it shows our Default instead.
   */
  const ComponentTag = layouts[layoutType]
    ? layouts[layoutType]
    : layouts["page_default"]

  return <ComponentTag {...layoutData} />
}

export default LandingPageBuilder
